export const accessKeys = {
    // Organization
    "inviteMemberToOrganization": 1,
    "updateTeamMemberStatus": 2,
    "viewTeamMembers": 3,

    // Link
    "generateShortLink": 4,
    "viewLinkList": 5,
    "updateDestinationLink": 7,
    "deleteLink": 8,
    "uploadBulkLink": 38,
    "setLinkExpiry": 57,
    "viewLinkDetails": 64,

    // QR
    "generateQr": 9,
    "viewQrList": 10,
    "deleteQr": 11,
    "viewQrDetails": 65,

    //Page
    "createAndEditPage": 12,
    "viewPageDetails": 14,
    "viewPageList": 15,
    "publishPage": 23,
    "deletePage": 25,
    "convertBitlyPage": 41,

    //Business Card
    "createAndEditBusinessCard": 26,
    "viewBusinessCardList": 28,
    "viewBusinessCardDetails": 29,
    "deleteBusinessCard": 32,
    "publishBusinessCard": 33,
    "viewBusinessCardAnalyticsCard": 36,
    "createBusinessCardQr": 37,

    //Rewards
    "addBankAccount": 42,
    "rewardWithdrawRequest": 43,
    "viewRewardList": 44,
    "viewRewardAnalyticsCard": 45,

    //DashBoard
    "viewDashboardCards": 47,
    "viewTopLinks": 6,
    "viewDeviceData": 48,
    "viewLocationData": 49,
    "viewReferrerData": 50,
    "viewDashboardGraph": 51,

    //Meta Analytics
    "setMetaCredentials": 58,
    "syncMetaAnalytics": 59,
    "viewMetaAnalytics": 60,

    //Access
    "viewAccessPresets": 61,
    "createAndEditPreset": 62,
    "assignAccessPreset": 63,

    // Google Ads
    "setGoogleAdsClientId": 66,
    "syncGoogleAds": 67,
    "viewGoogleAdsAnalytics": 68,

    //Agents
    "viewAgentDetails": 69,
    "createAndEditAgent": 70,
    "updateAgentStatus": 71,
    "linkAndUnlinkInfluencer": 72,

    //Influencer
    "viewInfluencerDetails": 73,
    "createAndEditInfluencer": 74,
    "updateInfluencerStatus": 75,
    "linkExistingAgent": 76,

    //Product
    "viewProductAndAppDetails": 77,
    "registerAndUpdateProduct": 78,
    "addAndUpdateApp": 79,

    //Promotion
    "createAndUpdatePromotion": 80,
    "viewPromotionDetails": 81,
    "deletePromotionLink": 82,

    // Attribution Dashboard
    "attributionDashboard": 83,

    // Live Chat
    "createAndUpdateCannedReplies": 84,
    "createAndUpdateChatSession": 85,
    "createAndUpdateNote": 86,
    "chatReportData": 87,
    "operatorDetails": 88,
    "assignChatPreset": 89,
    "chatPriceAndPlan": 90
}